var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('row',[_c(_vm.detailsComponent,{tag:"component",staticClass:"cell-in-row",attrs:{"item":_vm.item,"affiliated-plans":_vm.affiliatedPlans}}),_c(_vm.previewComponent,{tag:"component",staticClass:"cell-in-row",attrs:{"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }